export default __webpack_public_path__ + "assets/images/decor.ddc0e3.png";